import React from 'react';
import PropTypes from 'prop-types';
import SovosRaisedButton from 's1-ui/sovos-raised-button/SovosRaisedButton';
import SovosButtonsGroup from 's1-ui/sovos-buttons-group/SovosButtonsGroup';
import TextField from 'material-ui/TextField';
import ClearButton from 'material-ui/svg-icons/content/clear';

const initialState = {
  subGroupValues: ['', ''],
  columnValue: ''
};

class SubGroupsLabels extends React.PureComponent {
  state = { ...initialState };

  handleColumnIdentifierChange = (event, value) => {
    this.setState({ columnValue: value });
    this.props.profileActions.setPositionIdentifier(value);
  };

  handleLabelChange = (value, index) => this.setState(oldState => ({ subGroupValues: oldState.subGroupValues.map((v, i) => index === i ? value : v ) }));

  handleAddSubGroupClick = () => this.setState(oldState => ({ subGroupValues: [ ...oldState.subGroupValues, '' ] }));

  handleCancelClick = () => {
    this.setState({ ...initialState });
    this.props.onCancelLabels();
  };

  handleRemoveLabelClick = index => this.setState(oldState => {
    const months = [ ...oldState.subGroupValues ];
    months.splice(index, 1);
    return ({ subGroupValues: months });
  });

  render() {
    const fontColor = '#999';
    const { columnValue, subGroupValues } = this.state;
    return (
      <div className="map-columns__subgroup-options">
        <div className="map-columns__subgroup-position">
          <p className="map-columns__subgroup-bullet-number">1.)</p>
          <TextField
            name="subGroupColumn"
            underlineStyle={ { borderColor: fontColor } }
            style={ { width: 50 } }
            value={ columnValue }
            onChange={ this.handleColumnIdentifierChange }
          />
          <p className="map-columns__subgroup-paragraph">Column/position containing subgroup labels</p>
        </div>
        <div className="map-columns__subgroup-position">
          <p className="map-columns__subgroup-bullet-number">2.)</p>
          <div>
            {
              subGroupValues.map((value, index) => (
                <div className="map-columns__subgroup-label" key={ index }>
                  <TextField
                    name={ `subgroup-label-${index}` }
                    style={ { fontSize: 15, width: 400 } }
                    hintStyle={ { color: fontColor } }
                    underlineStyle={ { borderColor: fontColor } }
                    hintText={ `Subgroup Label ${index + 1 }` }
                    value={ value }
                    onChange={ (event, value) => this.handleLabelChange(value, index) }
                  />
                  {
                    subGroupValues.length > 2 &&
                    <ClearButton
                      style={ { borderBottom: `1px solid ${ fontColor }`, height: 40, cursor: 'pointer' } }
                      color={ fontColor }
                      onClick={ () => this.handleRemoveLabelClick(index) }
                    />
                  }
                </div>
              ))
            }
            <p className="map-columns__add-subgroup" onClick={ this.handleAddSubGroupClick }>+ Add Another Subgroup Label</p>
          </div>
        </div>
        <SovosButtonsGroup align="right" style={ { marginTop: 50 } }>
          <SovosRaisedButton onClick={ this.handleCancelClick } color="secondary">RESET</SovosRaisedButton>
          <SovosRaisedButton
            onClick={ () => this.props.onApplyLabels(columnValue, subGroupValues) }
            disabled={ columnValue === '' || subGroupValues.find(e => e === '') === '' }
            color="secondary"
          >
            APPLY
          </SovosRaisedButton>
        </SovosButtonsGroup>
      </div>
    );
  }
}

SubGroupsLabels.propTypes = {
  onApplyLabels: PropTypes.func.isRequired,
  onCancelLabels: PropTypes.func.isRequired,
  profileActions: PropTypes.shape({
    setPositionIdentifier: PropTypes.func
  }).isRequired
};

export default SubGroupsLabels;



// WEBPACK FOOTER //
// ./src/shared/components/mapColumns/c/subGroupsMenu/c/subGroupsLabels/SubGroupsLabels.js